import React, {useEffect,useContext} from 'react';
import './App.css';
import Navbar1 from './components/Navbar1';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import Home from './components/Home';
import Login from './components/Login';
import Panel from './components/panel';
import Panel2 from './components/panel2';
import Signup from './components/Signup';
import Addtocart from './components/Addtocart';

import { BrowserRouter as Router, Route,Routes} from "react-router-dom";
import { AuthContext } from './context/context';
import { Firebase } from './components/config';


function App() {
  const{setUser} = useContext(AuthContext)
  useEffect(()=>{
   Firebase.auth().onAuthStateChanged((user)=>{setUser(user)})
  })
  return (
    <Router><Navbar1/>
    <Routes> 
   <Route path='/' element={<Home/>}/>
  <Route path='/Login' element={<Login/>}/>
  <Route path='/Men' element={<Panel/>}/>
  <Route path='/Women' element={<Panel2/>}/>
  <Route path='/Signup' element={<Signup/>}/>
  <Route path='/Addtocart' element={<Addtocart/>}/>
  </Routes>
 


</Router>
   
  
  );
}

export default App;
